import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ContentBodyPadding, PageTitleHeight } from 'constants/layout';

type PageTitleProps = {
  children?: React.ReactNode;
  title: string;
};

export const PageTitle = ({ children, title }: PageTitleProps) => (
  <StyledContentWrapper>
    <p>{title}</p>
    {children}
  </StyledContentWrapper>
);

const StyledContentWrapper = styled.div(
  () => css`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    height: ${PageTitleHeight}px;
    padding: 0 ${ContentBodyPadding}px;
    white-space: pre-wrap;

    & p {
      display: flex;
      align-items: center;
      color: ${Color.Black};
      font-weight: ${FontWeight.Bold};
      ${Typography.Small};
    }
  `,
);
